import { FileFill, LightningFill, RoadDocLightCustom, RoadFillCustom } from '@profgeosoft-ui/icons';
import clsx from 'clsx';
import { observer } from 'mobx-react-lite';

import type { ViewSettings } from 'src/api/chart/drilling-plan-charts-api';
import BulldozerIcon from 'src/shared/assets/icons/bulldozer.svg';

import type { RSEReadiness } from '../../presets/drilling-rigs-chart/entities/rse-readiness';

import styles from './rse-readiness-icons.module.scss';

type Props = {
  readinessData: RSEReadiness;
  rseReadinessVisibilitySettings?: ViewSettings.SettingsControl[];
};

const defaultIconsVisibility: Record<(typeof rseSettingsFieldNames)[number], boolean> = {
  padReadiness: false,
  padDocumentationReadiness: false,
  routeReadiness: false,
  routeDocumentationReadiness: false,
  electricityReadiness: false,
};

export const rseSettingsFieldNames = [
  'padReadiness',
  'padDocumentationReadiness',
  'routeReadiness',
  'routeDocumentationReadiness',
  'electricityReadiness',
];

export const RSEReadinessIcons = observer<Props>(function RSEReadinessIcons({
  readinessData,
  rseReadinessVisibilitySettings,
}) {
  const { padReady, landReady, routeReady, routeDocumentationReady, electricityReady } = readinessData.padReadiness;
  const iconsOrder = rseReadinessVisibilitySettings
    ? rseReadinessVisibilitySettings?.reduce((acc: string[], settingsItem) => {
        const fieldId = settingsItem.values.fieldId;

        if (!rseSettingsFieldNames.includes(fieldId)) {
          return acc;
        }

        acc.push(fieldId);

        return acc;
      }, [])
    : rseSettingsFieldNames;

  const {
    padReadiness: padReadinessVisibility,
    padDocumentationReadiness: padDocumentationReadinessVisibility,
    routeReadiness: routeReadinessVisibility,
    routeDocumentationReadiness: routeDocumentationReadinessVisibility,
    electricityReadiness: electricityReadinessVisibility,
  } = rseReadinessVisibilitySettings
    ? rseReadinessVisibilitySettings.reduce((acc, settingsItem) => {
        const fieldId = settingsItem.values.fieldId;

        if (!rseSettingsFieldNames.includes(fieldId)) {
          return acc;
        }

        acc[fieldId] = settingsItem.values.isShown;

        return acc;
      }, defaultIconsVisibility)
    : defaultIconsVisibility;

  return (
    <div className={styles.wrapper}>
      {iconsOrder.map((fieldId) => {
        switch (fieldId) {
          case 'padReadiness': {
            return padReadinessVisibility ? (
              <BulldozerIcon key={fieldId} className={clsx(styles.icon, styles[padReady])} />
            ) : null;
          }

          case 'padDocumentationReadiness': {
            return padDocumentationReadinessVisibility ? (
              <FileFill key={fieldId} className={clsx(styles.icon, styles[landReady])} />
            ) : null;
          }

          case 'routeReadiness': {
            return routeReadinessVisibility ? (
              <RoadFillCustom key={fieldId} className={clsx(styles.icon, styles[routeReady])} />
            ) : null;
          }

          case 'routeDocumentationReadiness': {
            return routeDocumentationReadinessVisibility ? (
              <RoadDocLightCustom key={fieldId} className={clsx(styles.icon, styles[routeDocumentationReady])} />
            ) : null;
          }

          case 'electricityReadiness': {
            return electricityReadinessVisibility ? (
              <LightningFill key={fieldId} className={clsx(styles.icon, styles[electricityReady])} />
            ) : null;
          }
        }
      })}
    </div>
  );
});
